import type { LinkProps } from '@property.com.au/ui-kit';
import { Link, mediaHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent, PropsWithChildren } from 'react';
import styled from 'styled-components';
import type { ClickThroughSourceLocalStorageValue } from '../../../analytics/click-through-tracking/TrackingSource';
import { clickThroughSourceTracking } from '../../../analytics/click-through-tracking/clickThroughSourceTracking';
import { mapIconName } from '../../helpers/mapIconName';
import { mapLinkIconPlacement } from '../../helpers/mapLinkIconPlacement';
import { PcaLink, PcaLinkProps } from '../PcaLink/PcaLink';
import { IconInfo } from '../types';

const StyledLink = styled(Link)`
  ${mediaHelper('mobile')} {
    flex-grow: 1;
  }
`;

export interface InternalLinkProps extends LinkProps, PcaLinkProps {
  linkVariant?: LinkProps['variant'];
  iconInfo?: IconInfo | null;
  clickThroughTracking?: ClickThroughSourceLocalStorageValue | null;
  rel?: string;
}

export const InternalLink: FunctionComponent<PropsWithChildren<InternalLinkProps>> = ({
  linkVariant = 'primary',
  iconInfo,
  clickThroughTracking,
  children,
  rel = 'noopener',
  ...rest
}) => (
  <StyledLink
    forwardedAs={PcaLink}
    variant={linkVariant}
    sizeVariant="medium"
    icon={mapIconName(iconInfo?.name)}
    iconPlacement={mapLinkIconPlacement(iconInfo?.placement) ?? undefined}
    rel={rel}
    onClick={() => clickThroughSourceTracking(clickThroughTracking)}
    {...rest}
  >
    {children}
  </StyledLink>
);
